import { put, takeLatest } from 'redux-saga/effects';
import { GetLoggedUser } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction() {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/User/GetUser', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();

        const username = requestResult.Username;
        const codiceUtente = requestResult.CodiceUtente;
        const IsAuthenticated = requestResult.IsAuthenticated;


        yield put(GetLoggedUser.creators.getLoggedUserSuccess({ username, codiceUtente, IsAuthenticated }));

    } catch (e) {
        yield put(GetLoggedUser.creators.getLoggedUserFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GetLoggedUser.types.GET_LOGGED_USER_REQUEST, runAction);
}

